import React from 'react';
import classes from './Assessments.module.scss';
import t from '@/utils/Language/Assessments-translations.js';
import Assessment from './Assessment';
import useAssessments from '@/hooks/useAssessments';
import { STATUS_FINISHED, STATUS_STARTED } from '@/components/pages/assessments/util';

const userAssessmentsInStatus = (assessment, statuses) => {
  return assessment?.userAssessments?.filter?.((ua) => statuses.includes(ua.status)) || [];
};

const ASSESSMENT_GROUPS = [
  {
    statuses: [],
    title: 'new',
    assessmentShouldBeIncluded: (a) => {
      return !a.userAssessments?.length || userAssessmentsInStatus(a, [STATUS_STARTED]).length == 0;
    },
    includeUserAssessment: false
  },
  {
    statuses: [STATUS_STARTED],
    title: 'in-progress',
    assessmentShouldBeIncluded: (a) => {
      return userAssessmentsInStatus(a, [STATUS_STARTED]).length > 0;
    },
    includeUserAssessment: true
  },
  {
    statuses: [STATUS_FINISHED],
    title: 'completed',
    assessmentShouldBeIncluded: (a) => {
      return userAssessmentsInStatus(a, [STATUS_FINISHED]).length > 0;
    },
    includeUserAssessment: true
  }
];

const Assessments = ({ agencyClient }) => {
  const { assessments, userAssessments } = useAssessments({ agencyClientId: agencyClient?.id, includeUserAssessments: true, allowDuplicates: true });

  let merged = assessments;

  if (assessments.length > 0 && userAssessments.length > 0) {
    // add the user-specific properties (like status) from userAssessments
    // to the list of all available assessments
    merged = assessments.map((obj) => Object.assign(obj, { userAssessments: userAssessments.filter((ua) => ua.assessment_id === obj.id) }));
  }

  return (
    <div className={classes.container}>
      {ASSESSMENT_GROUPS.map((assessmentGroup) => {
        let assessmentsInGroup = merged.filter((a) => {
          return assessmentGroup.assessmentShouldBeIncluded(a);
        });
        if (assessmentsInGroup.length == 0) {
          return null;
        }

        return (
          <React.Fragment key={assessmentGroup.title}>
            <h3 className={classes.title}>{t(`section-${assessmentGroup.title}`)}</h3>
            <ul className={classes.list}>
              {assessmentsInGroup.map((a) => {
                if (!assessmentGroup.includeUserAssessment) {
                  return (
                    <div key={a.status + a.id}>
                      <Assessment assessment={a} status={null} agencyClient={agencyClient} />
                    </div>
                  );
                } else {
                  return userAssessmentsInStatus(a, assessmentGroup.statuses).map((ua) => {
                    return (
                      <div key={a.status + a.id + ua.id}>
                        <Assessment assessment={a} userAssessment={ua} status={ua.status} agencyClient={agencyClient} />
                      </div>
                    );
                  });
                }
              })}
            </ul>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Assessments;
